// ===== NIEUWE COMPONENT: FormattedChatBubble.jsx =====
import React from 'react';
import './ChatBubble.css';
import avatarImg from '../images/Job_avatar.webp';

const FormattedChatBubble = ({ who, type, children }) => {
  // Functie om tekst te formatteren
  const formatText = (text) => {
    if (!text || typeof text !== 'string') return text;
    
    // Split op dubbele line breaks voor paragraphs
    const paragraphs = text.split(/\n\s*\n/);
    
    return paragraphs.map((paragraph, index) => {
      // Check of het een vacature-sectie is (eindigt met :)
      if (paragraph.trim().endsWith(':') && paragraph.length < 100) {
        return (
          <div key={index} className="chat-section-header">
            <strong>{paragraph.trim()}</strong>
          </div>
        );
      }
      
      // Check voor bullet points
      if (paragraph.includes('•') || paragraph.includes('-')) {
        const lines = paragraph.split('\n');
        return (
          <div key={index} className="chat-paragraph">
            {lines.map((line, lineIndex) => {
              const trimmedLine = line.trim();
              if (trimmedLine.startsWith('•') || trimmedLine.startsWith('-')) {
                return (
                  <div key={lineIndex} className="chat-bullet-point">
                    {trimmedLine}
                  </div>
                );
              } else if (trimmedLine) {
                return (
                  <div key={lineIndex} className="chat-text-line">
                    {trimmedLine}
                  </div>
                );
              }
              return null;
            })}
          </div>
        );
      }
      
      // Gewone paragraph
      if (paragraph.trim()) {
        return (
          <div key={index} className="chat-paragraph">
            {paragraph.trim()}
          </div>
        );
      }
      
      return null;
    }).filter(Boolean);
  };

  const isBot = who === 'bot';

  return (
    <div className={`bubble-row ${who}`}>
      {isBot && (
        <img src={avatarImg} alt="Job" className="bubble-avatar" />
      )}
      <div className={`bubble ${who} ${type || ''}`}>
        <div className="bubble-content">
          {formatText(children)}
        </div>
      </div>
    </div>
  );
};

export default FormattedChatBubble;